import axios from '../../common/redux/interceptor';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_FETCH_OUTS_DATA_BEGIN,
  MANAGE_SUBS_FETCH_OUTS_DATA_SUCCESS,
  MANAGE_SUBS_FETCH_OUTS_DATA_FAILURE,
  MANAGE_SUBS_FETCH_OUTS_DATA_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
export function fetchOutsData(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_FETCH_OUTS_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      let conditions = args;
      if(args.sortedBy === undefined || args.sortedBy === null) {
        conditions = {
          ...conditions,
          sort: "ascend",
          sortedBy: "cutoff",
        }
      }
      if(conditions.nationalIds && conditions.nationalIds.length === 0) {
        delete conditions.natinalIds
      }
      if(conditions.itemCategory && conditions.itemCategory.length === 0) {
        delete conditions.itemCategory
      }
      // let path = '/getManageOutsData';
      // if(conditions.optimizationEnable){       //call optimization api
      //   path = '/manageOutsSearchOptimizeV2'; 
      // }
      // delete conditions.optimizationEnable; //COT-8330
      const doRequest = axios.post(`${API_REQUEST_URL}/manageOutsSearchOptimizeV2`, conditions, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          const data = res.data;
          if(data && data.data && data.data.length > 0) {
            const len = data.data.length
            for(let i = 0; i < len; i++) {
              data.data[i].uid = 'out' + i
            }
          }
          dispatch({
            type: MANAGE_SUBS_FETCH_OUTS_DATA_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_FETCH_OUTS_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchOutsDataError() {
  return {
    type: MANAGE_SUBS_FETCH_OUTS_DATA_DISMISS_ERROR,
  };
}

export function useFetchOutsData() {
  const dispatch = useDispatch();

  const { outsData, fetchOutsDataPending, fetchOutsDataError } = useSelector(
    state => ({
      outsData: state.manageSubs.outsData,
      fetchOutsDataPending: state.manageSubs.fetchOutsDataPending,
      fetchOutsDataError: state.manageSubs.fetchOutsDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchOutsData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchOutsDataError());
  }, [dispatch]);


  return {
    outsData,
    fetchOutsData: boundAction,
    fetchOutsDataPending,
    fetchOutsDataError,
    dismissFetchOutsDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_FETCH_OUTS_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchOutsDataPending: true,
        fetchOutsDataError: null,
      };

    case MANAGE_SUBS_FETCH_OUTS_DATA_SUCCESS:
      // The request is success
     
      return {
        ...state,
        outsData: action.data,
        fetchOutsDataPending: false,
        fetchOutsDataError: null,
      };

    case MANAGE_SUBS_FETCH_OUTS_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchOutsDataPending: false,
        fetchOutsDataError: action.data.error,
      };

    case MANAGE_SUBS_FETCH_OUTS_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchOutsDataError: null,
      };

    default:
      return state;
  }
}
